import { useCallback, useState } from 'react'
import { Form } from 'react-final-form'

import { authApi } from '../data'
import { TextField } from '@components/form-field/text'
import { Button } from '@elements/button'

export function ForgotPasswordForm() {
  const [responseMessage, setResponseMessage] = useState<string | undefined>()
  const submit = useCallback(async ({ email }: { email: string }) => {
    const { message } = await authApi.forgotPassword(email)
    setResponseMessage(message)
  }, [])

  if (responseMessage)
    return (
      <div>
        <p>{responseMessage}</p>
      </div>
    )

  return (
    <Form onSubmit={submit}>
      {({ handleSubmit }) => (
        <form
          onSubmit={handleSubmit}
          className="flex flex-col items-start justify-start w-full xs:min-w-[320px] max-w-lg space-y-6"
        >
          <TextField name="email" type="email" label="Email" />
          <Button.Submit className="w-full">Submit</Button.Submit>
        </form>
      )}
    </Form>
  )
}
